import './Fixture.css';
import React from 'react';
import PropTypes from 'prop-types';

import config from '@config';
import Metas from '@views/Metas';
import FixtureView from '@views/Fixture';

export const Fixture = ({}) => (
  <div className="Fixture">
    <Metas
      title={`Fixture Mundial 2026`}
      description="El juego de Página|12 para predecir los resultados del Mundial de Fútbol 2026"
    />
    <div className="hero-bg">
      <img
        src={`${config.basePath}/img/copa-header.svg`}
        alt=""
        className="header-cup"
      />
      <div className="hero-content">
        <h2>Fixture</h2>
        <p>Todos los partidos organizados por fecha</p>
      </div>
    </div>
    <div className="fixture-content">
      <div className="card">
        <FixtureView />
      </div>
    </div>
  </div>
);

Fixture.displayName = 'Fixture';
Fixture.propTypes = {};
Fixture.defaultProps = {};

export default Fixture;
